const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/tests/$testId.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/tests/$testId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});